import { render, staticRenderFns } from "./ClassesForm.vue?vue&type=template&id=66cc59b6&scoped=true&lang=html"
import script from "./ClassesForm.vue?vue&type=script&lang=js"
export * from "./ClassesForm.vue?vue&type=script&lang=js"
import style0 from "./ClassesForm.vue?vue&type=style&index=0&id=66cc59b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cc59b6",
  null
  
)

export default component.exports